const runtimeConfig = {
  // 常用控制变量 集中配置区域 起点 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
  videoWidth: 960, // 播放器的宽度（像素）
  videoHeight: 540, // 播放器的高度（像素）
  retry: true, // 拉流失败，是否自动重试
  maxRetryDuration: 1000 * 120, // 拉流重试的最大时长，单位为毫秒
  streamTimeoutTime: 1000 * 10, // 拉流超时时间，单位为毫秒，默认30秒
  poster: 'img/PlayerBG.png', // 设置播放器背景图
  // 设置默认视频源
  defaultVideoSrc: 'https://vod0j9f7jwb.vod.126.net/vod0j9f7jwb/bb2d6690-6155-453e-8afb-eb1bddee3fb8.mp4',
  // 常用控制变量 集中配置区域 终点 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑

  refreshMessage: '播放出现错误，正在进行重试...', // 播放器重试时的提示内容
  failedMessage: '播放出现错误，进行重试失败，已经停止播放。', // 重试失败后的提示内容
  // 自定义错误信息 终点 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑

  // 处理重试信息的变量 起点 ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
  streamType: 'vod', // 流类型：live/vod，默认为vod
  streamDuration: 0, // 保存流总时长的变量
  currentPosition: 0, // 保存当前播放位置的变量
  historyPosition: 0, // 保存最后播放位置的变量
  minTime: 1000 * 3, // 定义最后播放位置的最小值
  timer: null, // 保存当前播放位置的定时器
  refreshTimes: 0, // 刷新计数器
  // 处理重试信息的变量 终点 ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
}
const initConfig = {
  // 标准的 video 标签选项
  autoplay: true, // If true present as an attribute, begins playback when the player is ready.
  controls: true,
  width: 853, // Sets the display height of the video player in pixels.
  height: 480, // Sets the display height of the video player in pixels.
  loop: false, // Causes the video to start over as soon as it ends.
  muted: false, // muted: Will silence any audio by default.
  preload: 'auto',

  // Video.js-specific Options: Each option is undefined by default unless otherwise specified.
  techOrder: ['html5', 'flash'], // techOrder: Defines the order in which Video.js techs are preferred.
  streamTimeoutTime: 1000 * 10, // 拉流超时时间
  loadingSpinner: true, // loadingSpinner: A loading spinner for use during waiting/loading events.
  // bigPlayButton: false, // bigPlayButton: The initial play button that shows before the video has played.
  controlBar: { // controlBar: Container of main controls.
    playToggle: true, // playToggle: Button to toggle between play and pause. 播放暂停按钮
    volumeMenuButton: false, // volumeMenuButton: A Component to contain the MuteToggle and VolumeControl so that they can work together.
    currentTimeDisplay: false, // currentTimeDisplay: Displays the current time. (hidden by default)
    timeDivider: false, // timeDivider: The separator between the current time and duration. Can be hidden if it's not needed in the design. (hidden by default)
    durationDisplay: false, // durationDisplay: Displays the duration. (hidden by default)
    progressControl: false,
    liveDisplay: false, // liveDisplay: Displays the live indicator when duration is Infinity. (hidden during VOD playback)
    remainingTimeDisplay: false, // remainingTimeDisplay: Displays the time left in the video.
    // playbackRateMenuButton: { // playbackRateMenuButton: The component for controlling the playback rate. (hidden, unless playback tech supports rate changes)(当前只有html5模式才支持设置播放速率)
    //   playbackRates: [1, 2, 3],
    // },
    fullscreenToggle: true,
  },
  errorDisplay: false, // errorDisplay: A display that indicates an error has occurred. This means that the video is unplayable. (hidden, until there is an error)(使用自定义错误组件时，将此项设置为false)
}
const decryptKey = '5b6c051e1991e74d718b7f1b8cb525adfe11f7ed12737fda7aa56d79bc74c713'

export default {
  runtimeConfig,
  initConfig,
  decryptKey,
}
